import { IconButton } from "@mui/material";
import React from "react";
import SearchIcon from '@mui/icons-material/Search';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import SearchBar from "./SearchBar";
import { Box } from "@mui/system";

export default function SearchButton({ onClick, searchClicked }){

    return(
        <Box
            sx={{
                display:'flex'
            }}
        >
            <SearchBar searchClicked={searchClicked}/>
            <IconButton
                sx={{
                    backgroundColor:'#2a5da5',
                    color:'#fff',
                    p:'0.25rem',
                    width:{
                        xs:'52px',
                        md:'45px'
                    },
                    height:{
                        xs:'52px',
                        md:'45px'
                    },
                    m:'0 0.5rem 0 0',
                    '&:hover':{
                        backgroundColor:'#d85d31'
                    }
                }}
                onClick={onClick}
            >
                { searchClicked ? 
                    <FontAwesomeIcon icon={faTimes} /> 
                :
                    <SearchIcon/>
                }
            </IconButton>
        </Box>
    );
}